import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SelectBox, SelectBoxItem } from '@tremor/react';
import Alert from '../campaigns/alert/Alert';
import { useTestate, CreateTestataData } from '../../hooks/useTestate';
import { domainFromURL, isValidUrl } from '../../utils/utils';
import { toast } from 'react-hot-toast';

const FormTestate = () => {
  const { createTestata, loading } = useTestate();
  const navigate = useNavigate();

  // Local testata state
  const [testata, setTestata] = useState<CreateTestataData>({
    base_url: '',
    priority: 1,
    type: 'DISPLAY',
    urls: [],
  });
  const [urlError, setUrlError] = useState('');

  const handleUrlError = () => {
    setUrlError(
      !isValidUrl(testata.base_url) ? 'Il campo URL non è valido' : '',
    );
  };

  const handleSetChanges = (key: string, value: string | number) => {
    setTestata({
      ...testata,
      [key]: value,
    });
  };

  const handleSaveTestata = async () => {
    if (!isValidUrl(testata.base_url)) {
      toast.error('URL non valido');
      return;
    }

    const baseURL = domainFromURL(testata.base_url);
    const result = await createTestata({
      ...testata,
      base_url: baseURL
    });

    if (result.success) {
      // Redirect con filtro URL
      navigate('/admin/testate?testata=' + encodeURIComponent(btoa(baseURL)));
    }
  };

  return (
    <>
      <h3 className="user-form__title">Crea una nuova testata</h3>
      <div
        className={`user-form__form testate-form__form bg-transparent-white`}
      >
        <div className="row">
          <label>
            <span>*</span>URL
          </label>
          <input
            type="text"
            value={testata.base_url}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleSetChanges('base_url', e.target.value);
            }}
            onBlur={handleUrlError}
          />
          {urlError && <Alert alertTxt={urlError} />}
        </div>
        <div className="row">
          <label>
            <span>*</span>Priorità
          </label>
          <SelectBox
            value={testata.priority}
            onValueChange={(value: number) =>
              handleSetChanges('priority', value)
            }
          >
            <SelectBoxItem value={1} text="Bassa" />
            <SelectBoxItem value={2} text="Media" />
            <SelectBoxItem value={3} text="Alta" />
          </SelectBox>
        </div>
        <div className="row">
          <label>
            <span>*</span>Tipologia
          </label>
          <SelectBox
            value={testata.type}
            onValueChange={(value: string) => handleSetChanges('type', value)}
          >
            <SelectBoxItem value="DISPLAY" text="Display" />
            <SelectBoxItem value="PREROLL" text="Preroll" />
          </SelectBox>
        </div>
        <div
          className={`cta ${!isValidUrl(testata.base_url) || loading ? 'disabled' : ''}`}
          //onClick={handleSaveTestata}
          style={{ opacity: loading ? 0.7 : 1 }}
        >
          {loading ? 'Salvataggio...' : 'Salva'}
        </div>
      </div>
    </>
  );
};

export default FormTestate;
